var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.8015 64.5753C87.8864 59.0564 83.3385 54.3138 77.9774 51.0235L76.3584 38.5103C80.9869 34.8933 84.0215 29.3241 84.0215 23.0086C84.0215 17.5824 73.786 15.1104 64.2756 15.1104C54.7652 15.1104 44.5297 17.5824 44.5297 23.0088C44.5297 29.3246 47.5647 34.8941 52.1937 38.5111L50.5699 51.0272C45.2113 54.3146 40.665 59.0541 37.7497 64.5753C36.5041 66.9298 36.288 69.7952 37.152 72.4331C37.9426 74.8454 39.5855 76.8027 41.6546 77.8054C47.8623 80.8153 54.9449 81.8614 60.6871 82.1453L62.3048 108.039C62.3704 109.081 63.2323 109.891 64.2756 109.891C65.3187 109.891 66.1808 109.081 66.2464 108.039L67.8643 82.1453C73.6063 81.8614 80.6887 80.8154 86.8947 77.8073C88.9658 76.8027 90.6088 74.8454 91.3992 72.4331C92.263 69.7952 92.0471 66.9298 90.8015 64.5753Z",
    fill: "#344957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinedIcon);
export default __webpack_public_path__ + "static/media/pinedIcon.efa4399934c3cad5782955b23a2c5e25.svg";
export { ForwardRef as ReactComponent };